import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200' },
};

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-10 md:py-14" aria-label="分类导航">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            探索分类
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-5 rounded-xl border ${colors.border} ${colors.bg} hover:shadow-md transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${colors.bg} ${colors.text} group-hover:scale-110 transition-transform duration-200`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <span className={`text-sm font-semibold ${colors.text} whitespace-nowrap`}>
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}